var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.opened
    ? _c("div", { staticClass: "modal-mask" }, [
        _c("div", { staticClass: "modal-wrapper" }, [
          _c(
            "div",
            { staticClass: "modal-dialog modal-xl modal-dialog-scrollable" },
            [
              _c("div", { staticClass: "modal-content" }, [
                _c("div", { staticClass: "modal-header" }, [
                  _c("h5", { staticClass: "modal-title" }, [
                    _vm._v(_vm._s(_vm.dialogTitle)),
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "close",
                      attrs: { type: "button" },
                      on: { click: _vm.close },
                    },
                    [_vm._v("×")]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-body" }, [
                  !_vm.initialized
                    ? _c("h2", [
                        _c("i", { staticClass: "fa fa-spinner fa-spin" }),
                        _vm._v(" Loading..."),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.initialized
                    ? _c("div", { staticClass: "container-fluid" }, [
                        _c(
                          "form",
                          {
                            attrs: { id: "attribute-editor-dialog-form" },
                            on: {
                              submit: function ($event) {
                                $event.preventDefault()
                                return _vm.handleFormSubmit.apply(
                                  null,
                                  arguments
                                )
                              },
                            },
                          },
                          [
                            _c("div", { staticClass: "row" }, [
                              _c("div", { staticClass: "col-sm-6" }, [
                                _c("div", { staticClass: "form-group" }, [
                                  _vm._m(0),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model.trim",
                                        value: _vm.name,
                                        expression: "name",
                                        modifiers: { trim: true },
                                      },
                                    ],
                                    staticClass: "form-control",
                                    attrs: {
                                      type: "text",
                                      required: "",
                                      minlength: "2",
                                      maxlength: "100",
                                    },
                                    domProps: { value: _vm.name },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.name = $event.target.value.trim()
                                      },
                                      blur: function ($event) {
                                        return _vm.$forceUpdate()
                                      },
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("small", [
                                    _vm._v("Name of the attribute"),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "error" }, [
                                    _vm._v(_vm._s(_vm.nameError)),
                                  ]),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-sm-6" }, [
                                _c("div", { staticClass: "form-group" }, [
                                  _c("label", [_vm._v("Section")]),
                                  _vm._v(" "),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model.trim",
                                        value: _vm.section,
                                        expression: "section",
                                        modifiers: { trim: true },
                                      },
                                    ],
                                    staticClass: "form-control",
                                    attrs: { type: "text", maxlength: "100" },
                                    domProps: { value: _vm.section },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.section = $event.target.value.trim()
                                      },
                                      blur: function ($event) {
                                        return _vm.$forceUpdate()
                                      },
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("small", [
                                    _vm._v(
                                      "Name of the section. Use sections to group attributes e.g. financials."
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "error" }, [
                                    _vm._v(_vm._s(_vm.sectionError)),
                                  ]),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-sm-12" }, [
                                _c("div", { staticClass: "form-group" }, [
                                  _c("label", [_vm._v("Description")]),
                                  _vm._v(" "),
                                  _c("textarea", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model.trim",
                                        value: _vm.description,
                                        expression: "description",
                                        modifiers: { trim: true },
                                      },
                                    ],
                                    staticClass: "form-control",
                                    attrs: {
                                      type: "text",
                                      rows: "3",
                                      maxlength: "500",
                                    },
                                    domProps: { value: _vm.description },
                                    on: {
                                      input: function ($event) {
                                        if ($event.target.composing) return
                                        _vm.description =
                                          $event.target.value.trim()
                                      },
                                      blur: function ($event) {
                                        return _vm.$forceUpdate()
                                      },
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c("small", [
                                    _vm._v("Description of the attribute."),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "error" }, [
                                    _vm._v(_vm._s(_vm.descriptionError)),
                                  ]),
                                ]),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("hr"),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "row" },
                              [
                                _c("div", { staticClass: "col-sm-4" }, [
                                  _c("div", { staticClass: "form-group" }, [
                                    _c("label", [_vm._v("Type")]),
                                    _vm._v(" "),
                                    _c(
                                      "select",
                                      {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.attributeType,
                                            expression: "attributeType",
                                          },
                                        ],
                                        staticClass: "form-control",
                                        attrs: {
                                          disabled:
                                            !_vm.allowChangeAttributeType,
                                          required: "",
                                        },
                                        on: {
                                          change: function ($event) {
                                            var $$selectedVal =
                                              Array.prototype.filter
                                                .call(
                                                  $event.target.options,
                                                  function (o) {
                                                    return o.selected
                                                  }
                                                )
                                                .map(function (o) {
                                                  var val =
                                                    "_value" in o
                                                      ? o._value
                                                      : o.value
                                                  return val
                                                })
                                            _vm.attributeType = $event.target
                                              .multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "option",
                                          { attrs: { value: "Real" } },
                                          [_vm._v("Numeric")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          { attrs: { value: "Text" } },
                                          [_vm._v("Text")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          { attrs: { value: "MultilineText" } },
                                          [_vm._v("Multiline text")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          { attrs: { value: "Date" } },
                                          [_vm._v("Date")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "option",
                                          { attrs: { value: "Email" } },
                                          [_vm._v("Email")]
                                        ),
                                      ]
                                    ),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _vm.attributeType === "Real"
                                  ? _c("div", { staticClass: "col-sm-4" }, [
                                      _c("div", { staticClass: "form-group" }, [
                                        _c("label", [_vm._v("Input type")]),
                                        _vm._v(" "),
                                        _c(
                                          "select",
                                          {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value: _vm.inputType,
                                                expression: "inputType",
                                              },
                                            ],
                                            staticClass: "form-control",
                                            attrs: { required: "" },
                                            on: {
                                              change: function ($event) {
                                                var $$selectedVal =
                                                  Array.prototype.filter
                                                    .call(
                                                      $event.target.options,
                                                      function (o) {
                                                        return o.selected
                                                      }
                                                    )
                                                    .map(function (o) {
                                                      var val =
                                                        "_value" in o
                                                          ? o._value
                                                          : o.value
                                                      return val
                                                    })
                                                _vm.inputType = $event.target
                                                  .multiple
                                                  ? $$selectedVal
                                                  : $$selectedVal[0]
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "option",
                                              { attrs: { value: "Manual" } },
                                              [_vm._v("Enter value manually")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "option",
                                              { attrs: { value: "List" } },
                                              [_vm._v("Pick value from list")]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "option",
                                              {
                                                attrs: {
                                                  value: "Evaluate",
                                                  disabled:
                                                    _vm.allowInputTypeEvaluate ===
                                                    false,
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                                Based on formula\n                                            "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.attributeType !== "MultilineText"
                                  ? [
                                      _vm.attributeType !== "Real"
                                        ? _c(
                                            "div",
                                            { staticClass: "col-sm-4" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "form-group" },
                                                [
                                                  _c("label", [
                                                    _vm._v("Input type"),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c(
                                                    "select",
                                                    {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName: "v-model",
                                                          value: _vm.inputType,
                                                          expression:
                                                            "inputType",
                                                        },
                                                      ],
                                                      staticClass:
                                                        "form-control",
                                                      on: {
                                                        change: function (
                                                          $event
                                                        ) {
                                                          var $$selectedVal =
                                                            Array.prototype.filter
                                                              .call(
                                                                $event.target
                                                                  .options,
                                                                function (o) {
                                                                  return o.selected
                                                                }
                                                              )
                                                              .map(function (
                                                                o
                                                              ) {
                                                                var val =
                                                                  "_value" in o
                                                                    ? o._value
                                                                    : o.value
                                                                return val
                                                              })
                                                          _vm.inputType = $event
                                                            .target.multiple
                                                            ? $$selectedVal
                                                            : $$selectedVal[0]
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "option",
                                                        {
                                                          attrs: {
                                                            value: "Manual",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Enter value manually"
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "option",
                                                        {
                                                          attrs: {
                                                            value: "List",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Pick value from list"
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.allowMultipleValuesEnabled === true &&
                                      _vm.inputType !== "Evaluate"
                                        ? _c(
                                            "div",
                                            { staticClass: "col-sm-4" },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "form-group" },
                                                [
                                                  _c("label", [
                                                    _vm._v("Multi-select"),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    { staticClass: "checkbox" },
                                                    [
                                                      _c("label", [
                                                        _c("input", {
                                                          directives: [
                                                            {
                                                              name: "model",
                                                              rawName:
                                                                "v-model",
                                                              value:
                                                                _vm.isMultivalue,
                                                              expression:
                                                                "isMultivalue",
                                                            },
                                                          ],
                                                          attrs: {
                                                            type: "checkbox",
                                                          },
                                                          domProps: {
                                                            checked:
                                                              Array.isArray(
                                                                _vm.isMultivalue
                                                              )
                                                                ? _vm._i(
                                                                    _vm.isMultivalue,
                                                                    null
                                                                  ) > -1
                                                                : _vm.isMultivalue,
                                                          },
                                                          on: {
                                                            change: function (
                                                              $event
                                                            ) {
                                                              var $$a =
                                                                  _vm.isMultivalue,
                                                                $$el =
                                                                  $event.target,
                                                                $$c =
                                                                  $$el.checked
                                                                    ? true
                                                                    : false
                                                              if (
                                                                Array.isArray(
                                                                  $$a
                                                                )
                                                              ) {
                                                                var $$v = null,
                                                                  $$i = _vm._i(
                                                                    $$a,
                                                                    $$v
                                                                  )
                                                                if (
                                                                  $$el.checked
                                                                ) {
                                                                  $$i < 0 &&
                                                                    (_vm.isMultivalue =
                                                                      $$a.concat(
                                                                        [$$v]
                                                                      ))
                                                                } else {
                                                                  $$i > -1 &&
                                                                    (_vm.isMultivalue =
                                                                      $$a
                                                                        .slice(
                                                                          0,
                                                                          $$i
                                                                        )
                                                                        .concat(
                                                                          $$a.slice(
                                                                            $$i +
                                                                              1
                                                                          )
                                                                        ))
                                                                }
                                                              } else {
                                                                _vm.isMultivalue =
                                                                  $$c
                                                              }
                                                            },
                                                          },
                                                        }),
                                                        _vm._v(
                                                          " Allow multiple values\n                                                "
                                                        ),
                                                      ]),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  : _vm._e(),
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" "),
                            _vm.inputType === "Manual"
                              ? [
                                  _vm.attributeType === "Text"
                                    ? _c("div", { staticClass: "row" }, [
                                        _c("div", { staticClass: "col-sm-4" }, [
                                          _c("label", [_vm._v("Min length")]),
                                          _vm._v(" "),
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model.number",
                                                value: _vm.minLength,
                                                expression: "minLength",
                                                modifiers: { number: true },
                                              },
                                            ],
                                            staticClass: "form-control",
                                            attrs: {
                                              type: "number",
                                              min: "0",
                                              step: "1",
                                            },
                                            domProps: { value: _vm.minLength },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.minLength = _vm._n(
                                                  $event.target.value
                                                )
                                              },
                                              blur: function ($event) {
                                                return _vm.$forceUpdate()
                                              },
                                            },
                                          }),
                                        ]),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "col-sm-4" }, [
                                          _c("label", [_vm._v("Max length")]),
                                          _vm._v(" "),
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model.number",
                                                value: _vm.maxLength,
                                                expression: "maxLength",
                                                modifiers: { number: true },
                                              },
                                            ],
                                            staticClass: "form-control",
                                            attrs: {
                                              type: "number",
                                              min: "1",
                                              step: "1",
                                            },
                                            domProps: { value: _vm.maxLength },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.maxLength = _vm._n(
                                                  $event.target.value
                                                )
                                              },
                                              blur: function ($event) {
                                                return _vm.$forceUpdate()
                                              },
                                            },
                                          }),
                                        ]),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.attributeType === "MultilineText"
                                    ? _c("div", { staticClass: "row" }, [
                                        _c("div", { staticClass: "col-sm-4" }, [
                                          _c("label", [_vm._v("Min length")]),
                                          _vm._v(" "),
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model.number",
                                                value: _vm.minLength,
                                                expression: "minLength",
                                                modifiers: { number: true },
                                              },
                                            ],
                                            staticClass: "form-control",
                                            attrs: {
                                              type: "number",
                                              min: "0",
                                              step: "1",
                                            },
                                            domProps: { value: _vm.minLength },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.minLength = _vm._n(
                                                  $event.target.value
                                                )
                                              },
                                              blur: function ($event) {
                                                return _vm.$forceUpdate()
                                              },
                                            },
                                          }),
                                        ]),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "col-sm-4" }, [
                                          _c("label", [_vm._v("Max length")]),
                                          _vm._v(" "),
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model.number",
                                                value: _vm.maxLength,
                                                expression: "maxLength",
                                                modifiers: { number: true },
                                              },
                                            ],
                                            staticClass: "form-control",
                                            attrs: {
                                              type: "number",
                                              min: "1",
                                              step: "1",
                                            },
                                            domProps: { value: _vm.maxLength },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.maxLength = _vm._n(
                                                  $event.target.value
                                                )
                                              },
                                              blur: function ($event) {
                                                return _vm.$forceUpdate()
                                              },
                                            },
                                          }),
                                        ]),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "col-sm-4" }, [
                                          _c("label", [
                                            _vm._v("Number of lines"),
                                          ]),
                                          _vm._v(" "),
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model.number",
                                                value: _vm.rows,
                                                expression: "rows",
                                                modifiers: { number: true },
                                              },
                                            ],
                                            staticClass: "form-control",
                                            attrs: {
                                              type: "number",
                                              min: "0",
                                              step: "1",
                                            },
                                            domProps: { value: _vm.rows },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.rows = _vm._n(
                                                  $event.target.value
                                                )
                                              },
                                              blur: function ($event) {
                                                return _vm.$forceUpdate()
                                              },
                                            },
                                          }),
                                        ]),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.attributeType === "Real"
                                    ? _c("div", { staticClass: "row" }, [
                                        _c("div", { staticClass: "col-sm-4" }, [
                                          _c("label", [_vm._v("Min value")]),
                                          _vm._v(" "),
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model.number",
                                                value: _vm.minValue,
                                                expression: "minValue",
                                                modifiers: { number: true },
                                              },
                                            ],
                                            staticClass: "form-control",
                                            attrs: { type: "number" },
                                            domProps: { value: _vm.minValue },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.minValue = _vm._n(
                                                  $event.target.value
                                                )
                                              },
                                              blur: function ($event) {
                                                return _vm.$forceUpdate()
                                              },
                                            },
                                          }),
                                        ]),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "col-sm-4" }, [
                                          _c("label", [_vm._v("Max value")]),
                                          _vm._v(" "),
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model.number",
                                                value: _vm.maxValue,
                                                expression: "maxValue",
                                                modifiers: { number: true },
                                              },
                                            ],
                                            staticClass: "form-control",
                                            attrs: { type: "number" },
                                            domProps: { value: _vm.maxValue },
                                            on: {
                                              input: function ($event) {
                                                if ($event.target.composing)
                                                  return
                                                _vm.maxValue = _vm._n(
                                                  $event.target.value
                                                )
                                              },
                                              blur: function ($event) {
                                                return _vm.$forceUpdate()
                                              },
                                            },
                                          }),
                                        ]),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.attributeType === "Date"
                                    ? _c("div", { staticClass: "row" }, [
                                        _c(
                                          "div",
                                          { staticClass: "col-sm-4" },
                                          [
                                            _c("label", [_vm._v("Min value")]),
                                            _vm._v(" "),
                                            _c("DatePicker", {
                                              attrs: { value: _vm.minDate },
                                              on: {
                                                change: _vm.onMinDateChanged,
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "col-sm-4" },
                                          [
                                            _c("label", [_vm._v("Max value")]),
                                            _vm._v(" "),
                                            _c("DatePicker", {
                                              attrs: { value: _vm.maxDate },
                                              on: {
                                                change: _vm.onMaxDateChanged,
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ])
                                    : _vm._e(),
                                ]
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.inputType === "List"
                              ? [
                                  _c("div", { staticClass: "mt-3" }, [
                                    _c(
                                      "button",
                                      {
                                        staticClass:
                                          "btn btn-sm btn-outline-secondary",
                                        on: { click: _vm.addDefinedValue },
                                      },
                                      [_vm._v("Add value")]
                                    ),
                                    _vm._v(" "),
                                    _vm.attributeType === "Real"
                                      ? _c(
                                          "div",
                                          { staticClass: "dropdown d-inline" },
                                          [
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn btn-sm btn-outline-secondary dropdown-toggle",
                                                attrs: {
                                                  "data-toggle": "dropdown",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                            Scales templates\n                                        "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "dropdown-menu",
                                                staticStyle: {
                                                  "max-height": "300px",
                                                  "overflow-y": "auto",
                                                },
                                              },
                                              _vm._l(_vm.scales, function (s) {
                                                return _c(
                                                  "a",
                                                  {
                                                    key: s.Id,
                                                    staticClass:
                                                      "dropdown-item",
                                                    on: {
                                                      click: function ($event) {
                                                        _vm.definedValues =
                                                          s.Levels
                                                      },
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                                                " +
                                                        _vm._s(s.Name) +
                                                        "\n                                            "
                                                    ),
                                                  ]
                                                )
                                              }),
                                              0
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "row mt-3" }, [
                                    _vm._m(1),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "col-sm-4" }, [
                                      _c("label", [
                                        _vm._v(
                                          "\n                                            " +
                                            _vm._s(
                                              _vm.attributeType !== "Email"
                                                ? "Value"
                                                : "Email"
                                            ) +
                                            "\n                                        "
                                        ),
                                      ]),
                                    ]),
                                    _vm._v(" "),
                                    _vm._m(2),
                                  ]),
                                  _vm._v(" "),
                                  _vm._l(_vm.definedValues, function (dv) {
                                    return _c("div", [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "row",
                                          staticStyle: { "margin-top": "5px" },
                                        },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "col-sm-3" },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model.trim",
                                                    value: dv.Name,
                                                    expression: "dv.Name",
                                                    modifiers: { trim: true },
                                                  },
                                                ],
                                                staticClass: "form-control",
                                                attrs: {
                                                  type: "text",
                                                  required: "",
                                                  minlength: "2",
                                                  maxlength: "100",
                                                },
                                                domProps: { value: dv.Name },
                                                on: {
                                                  input: function ($event) {
                                                    if ($event.target.composing)
                                                      return
                                                    _vm.$set(
                                                      dv,
                                                      "Name",
                                                      $event.target.value.trim()
                                                    )
                                                  },
                                                  blur: function ($event) {
                                                    return _vm.$forceUpdate()
                                                  },
                                                },
                                              }),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "col-sm-4" },
                                            [
                                              _vm.attributeType === "Text"
                                                ? _c("div", [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName:
                                                            "v-model.trim",
                                                          value: dv.Value,
                                                          expression:
                                                            "dv.Value",
                                                          modifiers: {
                                                            trim: true,
                                                          },
                                                        },
                                                      ],
                                                      staticClass:
                                                        "form-control",
                                                      attrs: {
                                                        type: "text",
                                                        required: "",
                                                      },
                                                      domProps: {
                                                        value: dv.Value,
                                                      },
                                                      on: {
                                                        input: function (
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          )
                                                            return
                                                          _vm.$set(
                                                            dv,
                                                            "Value",
                                                            $event.target.value.trim()
                                                          )
                                                        },
                                                        blur: function (
                                                          $event
                                                        ) {
                                                          return _vm.$forceUpdate()
                                                        },
                                                      },
                                                    }),
                                                  ])
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.attributeType === "Real"
                                                ? _c("div", [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName:
                                                            "v-model.number",
                                                          value: dv.Value,
                                                          expression:
                                                            "dv.Value",
                                                          modifiers: {
                                                            number: true,
                                                          },
                                                        },
                                                      ],
                                                      staticClass:
                                                        "form-control",
                                                      attrs: {
                                                        type: "number",
                                                        required: "",
                                                      },
                                                      domProps: {
                                                        value: dv.Value,
                                                      },
                                                      on: {
                                                        input: function (
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          )
                                                            return
                                                          _vm.$set(
                                                            dv,
                                                            "Value",
                                                            _vm._n(
                                                              $event.target
                                                                .value
                                                            )
                                                          )
                                                        },
                                                        blur: function (
                                                          $event
                                                        ) {
                                                          return _vm.$forceUpdate()
                                                        },
                                                      },
                                                    }),
                                                  ])
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.attributeType === "Date"
                                                ? _c(
                                                    "div",
                                                    [
                                                      _c("DatePicker", {
                                                        attrs: {
                                                          value:
                                                            dv.Value != null
                                                              ? new Date(
                                                                  dv.Value
                                                                )
                                                              : null,
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            return _vm.onDefinedLevelDateChanged(
                                                              $event,
                                                              dv
                                                            )
                                                          },
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _vm.attributeType === "Email"
                                                ? _c("div", [
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName:
                                                            "v-model.trim",
                                                          value: dv.Value,
                                                          expression:
                                                            "dv.Value",
                                                          modifiers: {
                                                            trim: true,
                                                          },
                                                        },
                                                      ],
                                                      staticClass:
                                                        "form-control",
                                                      attrs: {
                                                        type: "email",
                                                        required: "",
                                                      },
                                                      domProps: {
                                                        value: dv.Value,
                                                      },
                                                      on: {
                                                        input: function (
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          )
                                                            return
                                                          _vm.$set(
                                                            dv,
                                                            "Value",
                                                            $event.target.value.trim()
                                                          )
                                                        },
                                                        blur: function (
                                                          $event
                                                        ) {
                                                          return _vm.$forceUpdate()
                                                        },
                                                      },
                                                    }),
                                                  ])
                                                : _vm._e(),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "col-sm-4" },
                                            [
                                              _c("textarea", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model.trim",
                                                    value: dv.Description,
                                                    expression:
                                                      "dv.Description",
                                                    modifiers: { trim: true },
                                                  },
                                                ],
                                                staticClass: "form-control",
                                                attrs: {
                                                  type: "text",
                                                  rows: "2",
                                                },
                                                domProps: {
                                                  value: dv.Description,
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    if ($event.target.composing)
                                                      return
                                                    _vm.$set(
                                                      dv,
                                                      "Description",
                                                      $event.target.value.trim()
                                                    )
                                                  },
                                                  blur: function ($event) {
                                                    return _vm.$forceUpdate()
                                                  },
                                                },
                                              }),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "col-sm-1" },
                                            [
                                              _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "btn btn-outline-secondary",
                                                  attrs: { type: "button" },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.removeDefinedValue(
                                                        dv
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _c("i", {
                                                    staticClass:
                                                      "fa fa-times-circle",
                                                  }),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ])
                                  }),
                                  _vm._v(" "),
                                  _vm._l(_vm.definedValuesErrors, function (e) {
                                    return _c("div", [
                                      _c("div", { staticClass: "error" }, [
                                        _vm._v(_vm._s(e)),
                                      ]),
                                    ])
                                  }),
                                ]
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.inputType === "Evaluate"
                              ? [
                                  _c("label", [_vm._v("Formula")]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "d-flex justify-content-end",
                                    },
                                    [
                                      _c("div", { staticClass: "dropdown" }, [
                                        _c(
                                          "button",
                                          {
                                            staticClass:
                                              "btn btn-sm btn-secondary dropdown-toggle",
                                            attrs: {
                                              "data-toggle": "dropdown",
                                            },
                                          },
                                          [_vm._v("Insert")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "dropdown-menu dropdown-menu-right",
                                            staticStyle: {
                                              "overflow-y": "auto",
                                              "max-height": "400px",
                                            },
                                          },
                                          _vm._l(
                                            _vm.numericAttributeNames,
                                            function (attrName) {
                                              return _c(
                                                "a",
                                                {
                                                  key: attrName,
                                                  staticClass: "dropdown-item",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.insertAttributeIntoScript(
                                                        attrName
                                                      )
                                                    },
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                                                " +
                                                      _vm._s(attrName) +
                                                      "\n                                            "
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "form-group" }, [
                                    _c("textarea", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.script,
                                          expression: "script",
                                        },
                                      ],
                                      ref: "ta",
                                      staticClass: "form-control",
                                      attrs: { rows: "5" },
                                      domProps: { value: _vm.script },
                                      on: {
                                        input: function ($event) {
                                          if ($event.target.composing) return
                                          _vm.script = $event.target.value
                                        },
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "error" }, [
                                      _vm._v(_vm._s(_vm.scriptError)),
                                    ]),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "a",
                                    {
                                      staticClass: "text-primary",
                                      on: {
                                        click: function ($event) {
                                          _vm.testScriptPanelVisible =
                                            !_vm.testScriptPanelVisible
                                        },
                                      },
                                    },
                                    [_vm._v("Test formula")]
                                  ),
                                  _vm._v(" "),
                                  _c("br"),
                                  _vm._v(" "),
                                  _vm.testScriptPanelVisible === true
                                    ? _c("div", [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "shadow-none p-3 mb-3 bg-light rounded",
                                          },
                                          [
                                            _vm._l(
                                              _vm.scriptTestInputs,
                                              function (i) {
                                                return _c(
                                                  "div",
                                                  {
                                                    staticClass: "form-inline",
                                                  },
                                                  [
                                                    _c("label", [
                                                      _vm._v(
                                                        _vm._s(i.Name) + ": "
                                                      ),
                                                    ]),
                                                    _vm._v(" "),
                                                    _c("input", {
                                                      directives: [
                                                        {
                                                          name: "model",
                                                          rawName:
                                                            "v-model.number",
                                                          value: i.Value,
                                                          expression: "i.Value",
                                                          modifiers: {
                                                            number: true,
                                                          },
                                                        },
                                                      ],
                                                      staticClass:
                                                        "form-control",
                                                      staticStyle: {
                                                        width: "90px",
                                                      },
                                                      attrs: { type: "number" },
                                                      domProps: {
                                                        value: i.Value,
                                                      },
                                                      on: {
                                                        input: function (
                                                          $event
                                                        ) {
                                                          if (
                                                            $event.target
                                                              .composing
                                                          )
                                                            return
                                                          _vm.$set(
                                                            i,
                                                            "Value",
                                                            _vm._n(
                                                              $event.target
                                                                .value
                                                            )
                                                          )
                                                        },
                                                        blur: function (
                                                          $event
                                                        ) {
                                                          return _vm.$forceUpdate()
                                                        },
                                                      },
                                                    }),
                                                  ]
                                                )
                                              }
                                            ),
                                            _vm._v(" "),
                                            _c("br"),
                                            _vm._v(" "),
                                            _c("div", { staticClass: "row" }, [
                                              _c(
                                                "div",
                                                { staticClass: "col-sm-6" },
                                                [
                                                  _c(
                                                    "button",
                                                    {
                                                      staticClass:
                                                        "btn btn-outline-secondary",
                                                      attrs: { type: "button" },
                                                      on: {
                                                        click:
                                                          _vm.handleLoadScriptTestResult,
                                                      },
                                                    },
                                                    [_vm._v("Test")]
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "col-sm-6" },
                                                [
                                                  _c(
                                                    "h3",
                                                    {
                                                      staticStyle: {
                                                        margin: "0",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                                                    Result: " +
                                                          _vm._s(
                                                            _vm.scriptTestResult
                                                          ) +
                                                          "\n                                                "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]),
                                          ],
                                          2
                                        ),
                                      ])
                                    : _vm._e(),
                                ]
                              : _vm._e(),
                          ],
                          2
                        ),
                      ])
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "modal-footer" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary",
                      attrs: {
                        type: "submit",
                        form: "attribute-editor-dialog-form",
                        disabled: !_vm.initialized,
                      },
                    },
                    [_vm._v(_vm._s(_vm.confirmButtonLabel))]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-secondary",
                      attrs: { type: "button" },
                      on: { click: _vm.close },
                    },
                    [_vm._v("Close")]
                  ),
                ]),
              ]),
            ]
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("label", [
      _c("span", { staticClass: "text-danger" }, [_vm._v("*")]),
      _vm._v(" Name"),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "col-sm-3" }, [
      _c("label", [_vm._v("Name")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "col-sm-4" }, [
      _c("label", [_vm._v("Description")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }